import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type IIdSelection} from '@netx/core-next/types';
import {getPersonDefaultFilters, type IPerson} from '../schema';
import {type GetPeopleRequestOptions} from './getPeople';
import {pollUntil} from '@netx/core-next/utils';

export interface HidePeopleRequestOptions extends Pick<
	GetPeopleRequestOptions,
	'filters'
> {
	selection: IIdSelection<string>;
}

export type HidePeopleRequest = [
	HidePeopleRequestOptions['selection'],
	HidePeopleRequestOptions['filters'],
];

export type HidePeopleResponse = SuccessResponse<string>; // uuid

export type HidePeopleResult = boolean;

export const hidePeopleEndpoint = 'hidePeople';

export const hidePeople = async (
	{selection, filters}: HidePeopleRequestOptions,
	signal?: AbortSignal,
): Promise<boolean> => {
	const client = NetxQueryClient();

	const requestParams: HidePeopleRequest = [
		selection,
		getPersonDefaultFilters({filters}),
	];

	return client
		.post<HidePeopleResponse>(hidePeopleEndpoint, requestParams, {signal})
		.then((response) => {
			return pollUntil({uuid: response.data.result}).then((result) => {
				return true;
			});
		});
};

export default hidePeople;
